// App
export const APP_SESSION_INFO_SET = 'APP_SESSION_INFO_SET';

// Nav
export const NAV_SET_BREADCRUMBS = 'NAV_SET_BREADCRUMBS';

/*
  -----------------

  Supplier payments

  -----------------
 */
// General
export const SUPPLIER_PAYMENTS_CLEAR = 'SUPPLIER_PAYMENTS_CLEAR';

// Filters
export const SUPPLIER_PAYMENTS_FILTER_LOAD_PENDING = 'SUPPLIER_PAYMENTS_FILTER_LOAD_PENDING';
export const SUPPLIER_PAYMENTS_FILTER_LOAD_SUCCESS = 'SUPPLIER_PAYMENTS_FILTER_LOAD_SUCCESS';
export const SUPPLIER_PAYMENTS_FILTER_LOAD_FAILURE = 'SUPPLIER_PAYMENTS_FILTER_LOAD_FAILURE';
export const SUPPLIER_PAYMENTS_FILTER_TYPE_CHANGE = 'SUPPLIER_PAYMENTS_FILTER_TYPE_CHANGE';
export const SUPPLIER_PAYMENTS_FILTER_ARRIVAL_FROM_CHANGE = 'SUPPLIER_PAYMENTS_FILTER_ARRIVAL_FROM_CHANGE';
export const SUPPLIER_PAYMENTS_FILTER_ARRIVAL_TO_CHANGE = 'SUPPLIER_PAYMENTS_FILTER_ARRIVAL_TO_CHANGE';
export const SUPPLIER_PAYMENTS_FILTER_PAID_FROM_CHANGE = 'SUPPLIER_PAYMENTS_FILTER_PAID_FROM_CHANGE';
export const SUPPLIER_PAYMENTS_FILTER_PAID_TO_CHANGE = 'SUPPLIER_PAYMENTS_FILTER_PAID_TO_CHANGE';
export const SUPPLIER_PAYMENTS_FILTER_PRODUCTS_CHANGE = 'SUPPLIER_PAYMENTS_FILTER_PRODUCTS_CHANGE';
export const SUPPLIER_PAYMENTS_FILTER_BRANDS_CHANGE = 'SUPPLIER_PAYMENTS_FILTER_BRANDS_CHANGE';
export const SUPPLIER_PAYMENTS_FILTER_DOMAINS_CHANGE = 'SUPPLIER_PAYMENTS_FILTER_DOMAINS_CHANGE';
export const SUPPLIER_PAYMENTS_FILTER_SUPPLIERS_CHANGE = 'SUPPLIER_PAYMENTS_FILTER_SUPPLIERS_CHANGE';
export const SUPPLIER_PAYMENTS_FILTER_SUPPLIERS_SEARCH = 'SUPPLIER_PAYMENTS_FILTER_SUPPLIERS_SEARCH';

// List
export const SUPPLIER_PAYMENTS_LIST_DOWNLOAD_PENDING = 'SUPPLIER_PAYMENTS_LIST_DOWNLOAD_PENDING';
export const SUPPLIER_PAYMENTS_LIST_DOWNLOAD_SUCCESS = 'SUPPLIER_PAYMENTS_LIST_DOWNLOAD_SUCCESS';
export const SUPPLIER_PAYMENTS_LIST_DOWNLOAD_FAILURE = 'SUPPLIER_PAYMENTS_LIST_DOWNLOAD_FAILURE';
export const SUPPLIER_PAYMENTS_SPEC_DOWNLOAD_PENDING = 'SUPPLIER_PAYMENTS_SPEC_DOWNLOAD_PENDING';
export const SUPPLIER_PAYMENTS_SPEC_DOWNLOAD_SUCCESS = 'SUPPLIER_PAYMENTS_SPEC_DOWNLOAD_SUCCESS';
export const SUPPLIER_PAYMENTS_SPEC_DOWNLOAD_FAILURE = 'SUPPLIER_PAYMENTS_SPEC_DOWNLOAD_FAILURE';
export const SUPPLIER_PAYMENTS_LIST_LOAD_PENDING = 'SUPPLIER_PAYMENTS_LIST_LOAD_PENDING';
export const SUPPLIER_PAYMENTS_LIST_LOAD_SUCCESS = 'SUPPLIER_PAYMENTS_LIST_LOAD_SUCCESS';
export const SUPPLIER_PAYMENTS_LIST_LOAD_FAILURE = 'SUPPLIER_PAYMENTS_LIST_LOAD_FAILURE';

/*
  -----------------

  Client payments

  -----------------
 */
// General
export const CLIENT_PAYMENTS_CLEAR = 'CLIENT_PAYMENTS_CLEAR';

// Filters
export const CLIENT_PAYMENTS_FILTER_LOAD_PENDING = 'CLIENT_PAYMENTS_FILTER_LOAD_PENDING';
export const CLIENT_PAYMENTS_FILTER_LOAD_SUCCESS = 'CLIENT_PAYMENTS_FILTER_LOAD_SUCCESS';
export const CLIENT_PAYMENTS_FILTER_LOAD_FAILURE = 'CLIENT_PAYMENTS_FILTER_LOAD_FAILURE';
export const CLIENT_PAYMENTS_FILTER_ARRIVAL_FROM_CHANGE = 'CLIENT_PAYMENTS_FILTER_ARRIVAL_FROM_CHANGE';
export const CLIENT_PAYMENTS_FILTER_ARRIVAL_TO_CHANGE = 'CLIENT_PAYMENTS_FILTER_ARRIVAL_TO_CHANGE';
export const CLIENT_PAYMENTS_FILTER_PAID_FROM_CHANGE = 'CLIENT_PAYMENTS_FILTER_PAID_FROM_CHANGE';
export const CLIENT_PAYMENTS_FILTER_PAID_TO_CHANGE = 'CLIENT_PAYMENTS_FILTER_PAID_TO_CHANGE';
export const CLIENT_PAYMENTS_FILTER_BRANDS_CHANGE = 'CLIENT_PAYMENTS_FILTER_BRANDS_CHANGE';
export const CLIENT_PAYMENTS_FILTER_DOMAINS_CHANGE = 'CLIENT_PAYMENTS_FILTER_DOMAINS_CHANGE';

// List
export const CLIENT_PAYMENTS_LIST_DOWNLOAD_PENDING = 'CLIENT_PAYMENTS_LIST_DOWNLOAD_PENDING';
export const CLIENT_PAYMENTS_LIST_DOWNLOAD_SUCCESS = 'CLIENT_PAYMENTS_LIST_DOWNLOAD_SUCCESS';
export const CLIENT_PAYMENTS_LIST_DOWNLOAD_FAILURE = 'CLIENT_PAYMENTS_LIST_DOWNLOAD_FAILURE';
export const CLIENT_PAYMENTS_SPEC_DOWNLOAD_PENDING = 'CLIENT_PAYMENTS_SPEC_DOWNLOAD_PENDING';
export const CLIENT_PAYMENTS_SPEC_DOWNLOAD_SUCCESS = 'CLIENT_PAYMENTS_SPEC_DOWNLOAD_SUCCESS';
export const CLIENT_PAYMENTS_SPEC_DOWNLOAD_FAILURE = 'CLIENT_PAYMENTS_SPEC_DOWNLOAD_FAILURE';
export const CLIENT_PAYMENTS_LIST_LOAD_PENDING = 'CLIENT_PAYMENTS_LIST_LOAD_PENDING';
export const CLIENT_PAYMENTS_LIST_LOAD_SUCCESS = 'CLIENT_PAYMENTS_LIST_LOAD_SUCCESS';
export const CLIENT_PAYMENTS_LIST_LOAD_FAILURE = 'CLIENT_PAYMENTS_LIST_LOAD_FAILURE';

// Gift Vouchers
export const GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_PENDING = 'GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_PENDING';
export const GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_SUCCESS = 'GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_SUCCESS';
export const GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_FAILURE = 'GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_FAILURE';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_PENDING = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_PENDING';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_NOCONTENT = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_NOCONTENT';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_SUCCESS = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_SUCCESS';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_FAILURE = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_FAILURE';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_PENDING = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_PENDING';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_NOTFOUND = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_NOTFOUND';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_SUCCESS = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_SUCCESS';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_FAILURE = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_FAILURE';
export const GIFT_VOUCHER_SEARCH_CANCEL_SUCCESS = 'GIFT_VOUCHER_SEARCH_CANCEL_SUCCESS';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_DOWNLOAD_PENDING = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_DOWNLOAD_PENDING';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_DOWNLOAD_SUCCESS = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_DOWNLOAD_SUCCESS';
export const GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_DOWNLOAD_FAILURE = 'GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_DOWNLOAD_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/constants.js